import React from 'react';
import DatePicker from '../DatePicker';
import dayjs from 'dayjs';
    
const ClientInput = (props) => {
    if (props.type === 'date') {
        const handleDatePickerChange = (date) => {
            if (props.inputchangehandler) {
                const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
                props.inputchangehandler({
                    target: {
                        name: props.name,
                        value: formattedDate
                    }
                });
            }
        };

        const minDate = props.min ? dayjs(props.min).toDate() : undefined;

        return (
            <DatePicker
                className={props.className}
                placeholder={props.placeholder || "Select date"}
                onChange={handleDatePickerChange}
                value={props.value || null}
                disabled={props.disabled || props.readOnly}
                minDate={minDate}
                name={props.name}
                onBlur={props.onBlur}
                onFocus={props.onFocus}
            />
        );
    }

    const classes = "input px-3 input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline " + props.className;
    const handleKeyDown = (e) => {
        if (props.type === 'number' && ["e", "E", "+", "-"].includes(e.key)) {
            e.preventDefault();
        } 
    };
    return (
        <input
            className={classes}
            placeholder={props.placeholder || " "}
            onChange={(e) => props.inputchangehandler(e)}
            value={props.value}
            readOnly={props.readOnly}
            name={props.name}
            type={props.type}
            min={props.type === "date" ? props.min : "0"}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            id={props.id}
            autoComplete="off"
            // maxlength={props.maxLength}
            maxlength={props.maxLength}
            minlength={props.minLength}
            onKeyDown={handleKeyDown}
        />
    );
};

export default ClientInput;
